import {
  useDataChange,
  useDataIsSubmitting,
  useDataSubmit,
  useDataValue,
} from 'Simple/Data.js'
import isValidDate from 'date-fns/isValid'
import parseISO from 'date-fns/parseISO'

export function useOnClick(props) {
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'report',
    viewPath: props.viewPath,
  })

  return function onClick(value) {
    change(next => {
      next.selected_rows = null
      if (next.merged?.url) {
        try {
          URL.revokeObjectURL(next.merged.url)
        } catch (_) {}
      }
      next.merged = null
    })

    submit()
  }
}

export function useIsDisabled(props) {
  let isSubmitting = useDataIsSubmitting({
    context: 'report',
    viewPath: props.viewPath,
  })
  let value = useDataValue({
    viewPath: props.viewPath,
    context: 'report',
  })

  return (
    value.filter_values.due_buckets.length === 0 ||
    value.filter_values.location_ids.length === 0 ||
    isNaN(value.filter_values.min_amount) ||
    value.filter_values.min_amount < 0.01 ||
    !isValidDate(parseISO(value.filter_values.reference_date)) ||
    !isValidDate(parseISO(value.filter_values.transactions_start_date)) ||
    !isValidDate(parseISO(value.filter_values.transactions_end_date)) ||
    isSubmitting
  )
}
